module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox checkbox__early-delivery"
  }, [_c('label', [_c('input', {
    attrs: {
      "name": "early-invoice",
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.earlyInvoice,
      "checked": _vm.earlyInvoice
    },
    on: {
      "change": _vm.updateEarlyInvoice
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-checkbox"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295e55dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Checkout/EarlyInvoice.vue
// module id = 838
// module chunks = 0